/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aqua_Day_Duck_WorkInputs */

const fr_aqua_day_duck_work = /** @type {(inputs: Aqua_Day_Duck_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Défini ton mot de passe`)
};

/**

* @param {Aqua_Day_Duck_WorkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const aqua_day_duck_work = /** @type {((inputs?: Aqua_Day_Duck_WorkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aqua_Day_Duck_WorkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_aqua_day_duck_work(inputs)
});